module.exports = __webpack_public_path__ + "img/product-inventory-saq.f47160f7.png";